import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import './styles.scss'
import { meetAPI } from 'api'
import { addConversation } from 'redux/actions/conversations/conversations'
import { setActiveUser } from 'redux/actions/tabs'
import { composerAct } from 'redux/actions'
import { Button } from 'components/Form'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'
import { toastMessage } from 'utils/messages'

const PersonBox = props => {
  const { _conversationId, conversationId, picture, name, delegation, channel, state } = props
  const dispatch = useDispatch()
  const { push } = useHistory()
  const [loadingMeetLink, setLoadingMeetLink] = useState(false)

  const handleClickToCall = () => {
    setLoadingMeetLink(true)

    meetAPI.createLink({ conversationId: _conversationId })
      .then(({ data }) => {
        const user = { _id: _conversationId, id: conversationId, channels: [channel], state, isOnline: false }
        dispatch(addConversation(user))
        dispatch(setActiveUser(conversationId))
        dispatch(composerAct.addExternalText(data.message || `${lang('dashboard_meet-link-created')}:`))
        dispatch(composerAct.updateButtons([
          { label: lang('dashboard_videocall'), content: data.url, type: 'url' }
        ]))
        navigator.clipboard.writeText(data.url)
        toastMessage(lang('dashboard_videocall-url-copied-clipboard'))
        push({
          pathname: '/dashboard/conversations/users',
          search: `?user_id=${conversationId}`
        })
      })
      .catch(() => toastMessage(lang('dashboard_error-generating-videocall-link'), 'error'))
  }

  return (
    <div className='search-results-person-box'>
      <figure className='search-results-person-box__avatar'>
        <img
          src={picture || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
          alt={name}
          onError={({ target }) => target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')}
        />
      </figure>
      <div className='search-results-person-box__user-content'>
        <div className='search-results-person-box__user-info'>
          <strong className='search-results-person-box__user-name'>{name}</strong>
          <span className='search-results-person-box__user-role'>{delegation}</span>
        </div>
        <div className='search-results-person-box__user-actions'>
          <Button
            clearPrimary
            className='search-results-person-box__user-btn'
            icon={
              <figure className='search-results-person-box__icon'>
                <img src={getStaticImage('/icons/orange-brand/icon-chat-primary-dark.svg')} alt='Message' />
              </figure>
            }
            value={lang('dashboard_send-message')}
            onClick={() => push({
              pathname: '/dashboard/conversations/users',
              search: `?user_id=${conversationId}`
            })}
          />
          <Button
            clearPrimary
            className='search-results-person-box__user-btn'
            icon={
              !loadingMeetLink ? (
                <figure className='search-results-person-box__icon'>
                  <img src={getStaticImage('/icons/orange-brand/icon-videocall-primary-dark.svg')} alt='Videocall' />
                </figure>
              ) : (
                <Nixi1Spinner width='15px' height='15px' />
              )
            }
            value={lang('dashboard_videocall')}
            onClick={handleClickToCall}
          />
        </div>
      </div>
    </div>
  )
}

export default PersonBox
